<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="chevron-down"
			class="svg-inline--fa fa-chevron-down"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
			:class="{ up, down, right, left }"
		>
			<path
				class="light"
				fill="currentColor"
				d="M4.251 181.1C7.392 177.7 11.69 175.1 16 175.1c3.891 0 7.781 1.406 10.86 4.25l197.1 181.1l197.1-181.1c6.5-6 16.64-5.625 22.61 .9062c6 6.5 5.594 16.59-.8906 22.59l-208 192c-6.156 5.688-15.56 5.688-21.72 0l-208-192C-1.343 197.7-1.749 187.6 4.251 181.1z"
			></path>

			<path
				class="regular"
				fill="currentColor"
				d="M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z"
			></path>

			<path
				class="solid"
				fill="currentColor"
				d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ChevronIcon',
	components: { Icon },
	props: {
		...props,
		up: { type: Boolean, default: null },
		down: { type: Boolean, default: null },
		right: { type: Boolean, default: null },
		left: { type: Boolean, default: null },
	},
}
</script>
<style lang="scss" scoped>
svg {
	--duration: 150ms;
	&.up {
		--rotate: 180deg;
	}
	&.left {
		--rotate: 90deg;
	}
	&.right {
		--rotate: 270deg;
	}
}
</style>
